import * as React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
  Stack,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const DeleteDialogTransition = React.forwardRef(function DeleteDialogTransition(
  props,
  ref,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function DeleteConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Delete",
  loadingLabel = "Deleting...",
  cancelLabel = "Cancel",
  loading = false,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={DeleteDialogTransition}
      PaperProps={{
        sx: {
          borderRadius: 1.5,
          overflow: "hidden",
          boxShadow: "0 16px 42px rgba(15, 23, 42, 0.25)",
        },
      }}
    >
      <DialogTitle
        sx={{
          px: 2.5,
          py: 1.75,
          bgcolor: "#fde8e8",
          color: "#b91c1c",
          fontSize: 16,
          fontWeight: 800,
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <WarningAmberRoundedIcon sx={{ fontSize: 20 }} />
            <Box component="span">{title}</Box>
          </Stack>
          <IconButton
            size="small"
            onClick={onClose}
            disabled={loading}
            sx={{ color: "#b91c1c" }}
          >
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ px: 2.5, pt: 2.25, pb: 1 }}>
        <DialogContentText sx={{ color: "#667085", fontSize: 15 }}>
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 2, justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={loading}
          sx={{
            minWidth: 96,
            color: "#111",
            borderColor: "#dfdfdf",
            textTransform: "none",
            fontWeight: 800,
            "&:hover": { borderColor: "#cfcfcf", bgcolor: "#fafafa" },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={loading}
          sx={{
            minWidth: 96,
            bgcolor: "#c93a3a",
            textTransform: "none",
            fontWeight: 800,
            boxShadow: "0 8px 18px rgba(201, 58, 58, 0.24)",
            "&:hover": { bgcolor: "#b91c1c" },
          }}
        >
          {loading ? loadingLabel : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
